import React, {useContext} from 'react'

import Context from '@s-ui/react-context'
import EmptyCase, {emptyCaseDefaultSizes} from '@adv-mt/mt-empty-case-default'

const EmptyCaseAlerts = () => {
  const {domain, site} = useContext(Context)
  const config = domain.get('config')

  const emptyCaseProps = {
    imageSize: emptyCaseDefaultSizes.MEDIUM,
    imageUrl: `images/${site}/alerts/empty-alerts.svg`,
    title: 'EMPTY_CASE_ALERTS_CASE_TITLE',
    text: 'EMPTY_CASE_ALERTS_CASE_TEXT',
    buttonText: 'EMPTY_CASE_ALERTS_BUTTON_REDIRECT',
    buttonHref: config.get('page').SECOND_HAND_PATH_PATTERN
  }
  return <EmptyCase {...emptyCaseProps} />
}

EmptyCaseAlerts.displayName = 'EmptyCaseAlerts'

export default EmptyCaseAlerts
